<template>
  <div v-if="content.groupInfoList.length" >
    <span style="color:#248cfa;">{{item.text}}：</span>
    <el-select  :allow-create="content.configuration.indexOf( 1 ) != -1" :filterable="content.configuration.indexOf( 0 ) != -1" @change="onChange" size="mini" v-model="item.value">
      <el-option v-for="(it,ind) in content.groupInfoList" :key="it.id" :label="it.optionContent" :value="it.optionResult"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "dropDown",
  props: ['item','contentList'],
  data() {
    return {
      content: {
        groupInfoList: []
      }
    }
  },
  methods: {
    onChange(val) {
      this.changeHandler(val)
      this.$forceUpdate()
    },
    changeHandler(val) {
      console.log(this.content.groupInfoList.find(item => item.optionResult == val));
      let item = this.content.groupInfoList.find(item => item.optionResult == val)
      if(this.content.groupInfoList.findIndex(item => item.optionResult == val) != -1) {
        console.log(111);
      }else {
        this.addOneQuestionnaireOption({
          tagId: this.content.groupInfoList[0].tagId,
          optionContent: val
        })
      }

    },
    async addOneQuestionnaireOption(p) {
      this.$store.dispatch('requestHandler',{
        fn: 'RestNewQuestionnaireDesignCallcenterControllerAddOneQuestionnaireOption',
        params: {
          tagId: p.tagId,
          operatorId: sessionStorage.getItem('userid'),
          optionContent: p.optionContent,
        }
      })
    }
  },
  watch: {
    contentList: {
      handler(val) {
        if(val) {
          let result = this.contentList.find(item => item.tagId == this.item.contentId)
          this.content = result
        }
      },
      deep: true,
      immediate: true
    }
  },

}
</script>

<style lang="scss" scoped>

</style>